@defer (on idle; hydrate on viewport) {
    @if (similarVehicles().length > 0) {
        <div class="relative flex w-full flex-col overflow-x-hidden pt-48 pb-[70px] pl-24 lg:items-center">
            <div class="bg-grey-500 absolute bottom-0 left-0 h-[40%] w-full"></div>
            <h3 class="text-24 lg:text-34 mb-32 leading-29 lg:mb-64 lg:leading-41">{{ title() }}</h3>

            <div class="2lg:-translate-x-[762px] 2lg:justify-end flex w-full items-stretch justify-start gap-[128px]">
                <div class="2lg:flex relative hidden flex-nowrap items-center gap-8 whitespace-nowrap">
                    <button
                        class="z-[100]"
                        (click)="sliderRef.slider()?.prev()"
                        type="button"
                        aria-label="Vorheriges Fahrzeug anzeigen"
                    >
                        <i class="icon-chevron-left text-grey-400 text-[56px] md:!flex" aria-hidden="true"></i>
                    </button>

                    <button
                        class="z-[100]"
                        (click)="sliderRef.slider()?.next()"
                        type="button"
                        aria-label="Nächstes Fahrzeug anzeigen"
                    >
                        <i class="icon-chevron-right text-grey-400 text-[56px] md:!flex" aria-hidden="true"></i>
                    </button>
                    <!-- grund für diesen hack ist overflow-visible auf dem slider, weil wir nur die rechte seite zeigen wollen -->
                    <div class="2lg:block absolute -right-[140px] z-[1] hidden h-full w-[800px] bg-white"></div>
                    <div
                        class="bg-grey-500 2lg:block absolute -right-[140px] bottom-0 z-[1] hidden w-[800px] lg:h-[150px] xl:h-[160px]"
                    ></div>
                </div>

                <div class="w-full max-w-[342px] lg:max-w-[379px]">
                    <div class="keen-slider !overflow-visible" #sliderRef [sliderOptions]="sliderOptions" cdkSlider>
                        @for (vehicle of similarVehicles(); track vehicle) {
                            <div class="keen-slider__slide w-full" cdkSlide>
                                <lib-vehicle-card
                                    class="block h-full max-w-[342px] px-12 shadow-[0px_4px_20.6px_0px_rgba(0,_0,_0,_0.11)] lg:max-w-[379px]"
                                    [vehicle]="vehicle"
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div
                class="z-[1] mt-[40px] flex items-center justify-center gap-8"
                role="navigation"
                aria-label="Seitennavigation des Fahrzeug-Sliders"
            >
                @for (item of similarVehicles(); track item) {
                    <button
                        class="size-14 rounded-full transition-all duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white/70"
                        [ngClass]="$index === currentSlide() ? 'border-blue bg-blue' : 'border-grey-400 bg-white'"
                        [attr.aria-label]="`Folie ${$index + 1} von ${similarVehicles().length} anzeigen`"
                        [attr.aria-current]="$index === currentSlide() ? 'page' : null"
                        (click)="sliderRef.goToIndex($index)"
                        type="button"
                    ></button>
                }
            </div>

            <ng-content select="[link]" />
        </div>
    }
}
